<template>
  <b-navbar toggleable="lg" type="light" variant="white" sticky class="shadow-sm">
    <slot></slot>
  </b-navbar>
</template>

<script>
export default {};
</script>